import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

//工作动态列表查询
export function qryWorkDynamicsList(data) {
  return request({
    url: "/apis/pp/users/signup/thirdParty/qryWorkDynamicsList",
    method: "post",
    data
  });
}
export function getSkuRecommendList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_EMP_URL) +
      "/apis/ccem/cmc/users/signup/getSkuRecommendList",
    method: "post",
    data
  });
}
// 钢铁价格
export function selectPortalTypeList(data) {
  return request({
    url: "/apis/pp/users/signup/thirdParty/selectPortalTypeList",
    method: "post",
    data
  });
}
export function searchSupNoticeNew(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_SP_URL) +
      "/apis/sp/bidc/users/signup/searchSupNoticeNew",
    method: "post",
    data
  });
}
export function selectPortalCityList(data) {
  return request({
    url: "/apis/pp/users/signup/thirdParty/selectPortalCityList",
    method: "post",
    data
  });
}
export function selectPortalInfoList(data) {
  return request({
    url: "/apis/pp/users/signup/thirdParty/selectPortalInfoList",
    method: "post",
    data
  });
}
//供应商协同公告列表查询
export function listSupBidNotice(data) {
  return request({
    url: "/apis/pp/bidc/users/signup/listSupBidNotice",
    method: "post",
    data
  });
}
//采购方公告列表查询
export function searchPpBidNotice(data) {
  return request({
    url: "/apis/pp/bidc/users/signup/selectPublicBidNoticeList",
    method: "post",
    data
  });
}
export function qryMySteelTrendInfo(data) {
  return request({
    url: "/apis/pp/users/signup/thirdParty/qryMySteelTrendInfo",
    method: "post",
    data
  });
}
//供应商协同公告详情查询
export function qryNoticeDetail(data) {
  return request({
    url: "/apis/pp/bidc/users/signup/qryNoticeDetail",
    method: "post",
    data
  });
}
//除通知公告, 工作动态, 市场动态, 价格信息栏目外 详情使用此接口
export function selectPulicBidNoticeDetail(data) {
  return request({
    url: "/apis/pp/bidc/users/signup/selectPulicBidNoticeDetail",
    method: "post",
    data
  });
}
export function qryWorkDynamicsDetail(data) {
  return request({
    url: "/apis/pp/users/signup/thirdParty/qryWorkDynamicsDetail",
    method: "post",
    data
  });
}
//查询包件信息
export function queryProcessSchemeMatDetail(data) {
  return request({
    url: "/apis/sp/bidc/queryProcessSchemeMatDetail",
    method: "post",
    data
  });
}
//查询相关公告列表
export function qryNoticeList(data) {
  return request({
    url: "/apis/sp/bidc/qryNoticeList",
    method: "post",
    data
  });
}
//查询寻源完成累计金额和项目数量查询
export function qryFinishedAmountAndProjectNum(data) {
  return request({
    url: "/apis/pp/bidc/users/signup/qryFinishedAmountAndProjectNum",
    method: "post",
    data
  });
}

//通知公告、工作动态、湖北供应商推荐
export function queryPublishedNoticeList(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/cmc/noticeInfo/queryPublishedNoticeList",
    method: "post",
    data
  });
}

//通知公告详情
export function queryNoticeById(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/cmc/noticeInfo/queryNoticeById",
    method: "post",
    data
  });
}

//宣传海报
export function qryPostersList(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/cmc/pubcontent/qryPostersList",
    method: "post",
    data
  });
}

//轮播图点击量统计
export function updateHits(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/cmc/pubcontent/updateHits",
    method: "post",
    data
  });
}

//操作指南
export function queryNoviceGuide(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/cmc/noviceGuide/queryNoviceGuide",
    method: "post",
    data
  });
}

//常见问题列表
export function listFaqProblem(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/hc/faqProblem/listFaqProblem",
    method: "post",
    data
  });
}

//查看常见问题详情
export function getFaqProblemById(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/hc/faqProblem/getFaqProblemById",
    method: "post",
    data
  });
}

//查询友情链接
export function queryFriendshipAddressPage(data) {
  return request({
    url: "/apis/pp/users/signup/friendship/queryFriendshipAddressPage",
    method: "post",
    data
  });
}
//查询友情链接明细
export function queryFriendshipAddressItemPage(data) {
  return request({
    url: "/apis/pp/users/signup/friendship/queryFriendshipAddressItemPage",
    method: "post",
    data
  });
}
//查询栏目内容列表（新接口）（海外集采价格专区、等等）
export function selectNoticeList(data) {
  return request({
    url: "/apis/pp/bidc/users/signup/selectNoticeList",
    method: "post",
    data
  });
}
//查询栏目内容列表（新接口）（海外集采价格专区、等等）
export function selectUserPortalRoleList(data) {
  return request({
    url: "/apis/pp/userPortalRole/users/signup/selectUserPortalRoleList",
    method: "post",
    data
  });
}

// 获取今日发布的主题数
export function qryGateWayForumPage(data) {
  return request({
    url: "/apis/pp/forum/gateway/users/signup/qryGateWayForumPage",
    method: "post",
    data
  });
}
//查询供应商接口
export function querySupplierDirectoryList(data) {
  return request({
    url: "/apis/pp/supDirectory/users/signup/querySupplierDirectoryList",
    method: "post",
    data
  });
}
//查询大区接口
export function qryAddressRegion(data) {
  return request({
    url: "/apis/pp/common/users/signup/qryAddressRegion",
    method: "post",
    data
  });
}
//查询大区下的（省市县）接口
export function qryAddressByCodeRegion(data) {
  return request({
    url: "/apis/pp/common/users/signup/qryAddressByCodeRegion",
    method: "post",
    data
  });
}
//查询物资编码接口
export function qryMatcateryTreeList(data) {
  return request({
    url: "/apis/pp/common/users/signup/qryMatcateryTreeList",
    method: "post",
    data
  });
}
// 版块详细主页
export function qryThemePage(data) {
  return request({
    url: "/apis/pp/forum/gateway/qryThemePage",
    method: "post",
    data
  });
}

// 字典
//查询供应商类型
export function listDictByCode(data) {
  return request({
    url: "/apis/pp/common/users/signup/listDictByCode",
    method: "post",
    data
  });
}
// 主题详情
export function selectForumTheme(data) {
  return request({
    url: "/apis/pp/forum/gateway/selectForumTheme",
    method: "post",
    data
  });
}
//查询供应商级别
export function qrySuptypeQualList(data) {
  return request({
    url: "/apis/pp/common/users/signup/qrySuptypeQualList",
    method: "post",
    data
  });
}

// 分页查询主题回复
export function qryThemeReplier(data) {
  return request({
    url: "/apis/pp/forum/gateway/qryThemeReplier",
    method: "post",
    data
  });
}

// 删除主题
export function delThemeByIds(data) {
  return request({
    url: "/apis/pp/forum/gateway/delThemeByIds",
    method: "post",
    data
  });
}

// 新增回复
export function saveReplier(data) {
  return request({
    url: "/apis/pp/forum/gateway/saveReplier",
    method: "post",
    data
  });
}

// 置顶开关
export function switchTop(data) {
  return request({
    url: "/apis/pp/forum/gateway/switchTop",
    method: "post",
    data
  });
}
// 精品开关
export function switchQuintessence(data) {
  return request({
    url: "/apis/pp/forum/gateway/switchQuintessence",
    method: "post",
    data
  });
}

// 新增主题
export function saveThemeDetail(data) {
  return request({
    url: "/apis/pp/forum/gateway/saveThemeDetail",
    method: "post",
    data
  });
}
// 关闭或开启主题
export function closeOrOpenTheme(data) {
  return request({
    url: "/apis/pp/forum/gateway/closeOrOpenTheme",
    method: "post",
    data
  });
}
export function addViewCount(data) {
  return request({
    url: "/apis/pp/forum/gateway/addViewCount",
    method: "post",
    data
  });
}

export function getALabel(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/getALabel",
    method: "post",
    data
  });
}

// 右侧悬浮购物车数量
export function cartNum(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_EMP_URL) +
      "/apis/ccem/emc/users/signup/cartNum",
    method: "post",
    data
  });
}
